import React, { Component } from 'react';
//i18n
import { withNamespaces } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Card, CardBody, CardTitle, Container } from 'reactstrap';
//Import form component to render
import Loader from '../../components/Common/Loader';
import { getEntryStrategies } from '../../store/actions';
import EntryStrategyList from '../../components/Lists/EntryStrategyList';
//Import Breadcrumb
import '../Tables/datatables.scss';

class SettingsEntryStrategies extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem('authUser')),
      entryStrategies: null,
      editable: false,
    };
  }
  componentDidMount() {
    this.props.getEntryStrategies(this.state.user.token);
  }
  componentDidUpdate(prevProps) {
    if (this.props.loadingGetEntryStrategies === false && prevProps.loadingGetEntryStrategies === true) {
      let entryStrategies = this.props.entryStrategies;
      if (entryStrategies) {
        this.setState({ entryStrategies: entryStrategies });
      }
    }
  }
  changeStatusFrom(event) {
    event.preventDefault();
    if (this.state.editable) {
      this.props.history.go();
    }
    this.setState({
      editable: !this.state.editable,
      entryStrategies: this.state.entryStrategies,
    });
  }
  render() {
    if (!this.state.entryStrategies) {
      return (
        <React.Fragment>
          <div className="loaderCenter">
            <Loader></Loader>
          </div>
        </React.Fragment>
      );
    }

    return (
      <React.Fragment>
        <div className="user-management">
          <Container fluid>
            <Card>
              <CardBody>
                <div className="mt-4 mb-4">
                  <CardTitle>{this.props.t('Estrategias de Entrada')}</CardTitle>
                </div>
                <EntryStrategyList entryStrategies={this.state.entryStrategies} editable={this.state.editable} />
              </CardBody>
            </Card>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateProps = (state) => {
  const { loadingGetEntryStrategies, entryStrategies } = state.getEntryStrategies;
  return { loadingGetEntryStrategies, entryStrategies };
};
export default withRouter(connect(mapStateProps, { getEntryStrategies })(withNamespaces()(SettingsEntryStrategies)));
